/**
 * @generated SignedSource<<8a6298afd19fd5ac0c7897afd9f1f096>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type JiraProjectType = "BUSINESS" | "CUSTOMER_SERVICE" | "PRODUCT_DISCOVERY" | "SERVICE_DESK" | "SOFTWARE" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type EditionAwareness_query$data = {
  readonly jira_projectByIdOrKey?: {
    readonly projectType: JiraProjectType | null;
  } | null;
  readonly " $fragmentType": "EditionAwareness_query";
};
export type EditionAwareness_query$key = {
  readonly " $data"?: EditionAwareness_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"EditionAwareness_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudId"
    },
    {
      "kind": "RootArgument",
      "name": "projectIdOrKey"
    },
    {
      "kind": "RootArgument",
      "name": "shouldFetchProjectTypeForSettingsAndEA"
    }
  ],
  "kind": "Fragment",
  "name": "EditionAwareness_query",
  "selections": [
    {
      "condition": "shouldFetchProjectTypeForSettingsAndEA",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "cloudId",
              "variableName": "cloudId"
            },
            {
              "kind": "Variable",
              "name": "idOrKey",
              "variableName": "projectIdOrKey"
            }
          ],
          "concreteType": "JiraProject",
          "kind": "LinkedField",
          "name": "jira_projectByIdOrKey",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "projectType"
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};

(node as any).hash = "cb12d32f3acd06fa4956f0b0bc163456";

export default node;
